import React, { useState } from 'react';
import LocationDropDown from '../utility/location';
import { SelectMenu, IconButton, useNexus } from '@spotoninc/nexus-react';
import { DownloadIcon } from '@spotoninc/nexus-web-assets';
import { HStack, Stack, useMediaQuery } from '@chakra-ui/react';
import '../../styles/reskinned-financial-type-dropdown.css';
import CustomLocationSelector from '../utility/customLocationSelector';

const viewTypeOptions = [
  { label: 'Overview', value: 'cost_amt' },
  { label: '% of cost', value: 'cost_per' },
  { label: '% of sales', value: 'sales_per' },
  { label: '% of budget', value: 'budget_per' },
];
export const FinancialInsightSubHeader = ({
  locationValue,
  setLocation,
  setViewType,
  handleDownload,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')[0];
  return (
    <Stack
      direction={{ base: 'column', md: 'row' }}
      spacing={4}
      justify="space-between"
      align={{ base: 'flex-start', md: 'center' }}
    >
      <HStack gap={4}>
        <SelectMenu
          className="reskinned-financial-type-dropdown"
          options={viewTypeOptions}
          initialValue={viewTypeOptions[0].value}
          onChange={setViewType}
          style={{ zIndex: 11 }}
        />
        {isMobile && (
          <IconButton
            icon={DownloadIcon}
            onClick={handleDownload}
            variant="tonal"
            size="medium"
            display={isMobile ? 'none' : 'block'}
          />
        )}
      </HStack>
      <HStack gap={4}>
        <CustomLocationSelector
          multiple
          locationValue={locationValue}
          setLocation={setLocation}
        />
        {!isMobile && (
          <IconButton
            icon={DownloadIcon}
            onClick={handleDownload}
            variant="tonal"
            size="medium"
            display={isMobile ? 'block' : 'none'}
          />
        )}
      </HStack>
    </Stack>
  );
};
